import CollectionModule from 'client/store/modules/CollectionModule';
import RadiusServerApi from 'client/api/v2/RadiusServerApi';

export class RadiusServerCollectionClass extends CollectionModule {}
export default new RadiusServerCollectionClass(RadiusServerApi, 'id', 'name').extractModule();
